jQuery(document).ready(function ($) {
  $('.smoothscroll').on('click', 'a', function (event) {
    if (this.hash !== '') {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate(
        {
          scrollTop: $(hash).offset().top - 120,
        },
        800
      );
    }
  });

  function createMobileRows(info, packA, id) {
    return (
      '<div class="mobile-pricing-row">' +
      '<div data-mob-id="' +
      id +
      '" class="mobile-pricing-info-icon"><img src="' +
      site_url +
      '/wp-content/themes/roubler-gold/images/info.svg?v=2"></div>' +
      '<div   class="mobile-pricing-label">' +
      $(info).find('div').first().find('div').first().text() +
      '</div>' +
      '<div class="mobile-pricing-includes">' +
      packA +
      '</div>' +
      '</div>' +
      '<div id="' +
      id +
      '" class="mobile-pricing-info">' +
      $(info).find('div').first().find('div.pricing-info-hover').text() +
      '</div>'
    );
  }

  var pricingTable = $('figure.pricing-table-v2 table');
  if (pricingTable) {
    $('body').on('click', '.mobile-pricing-info-icon', function () {
      $('#' + $(this).data('mob-id')).slideToggle();
    });
    var packageAOpen = false;
    var packageBOpen = false;
    var packageCOpen = false;
    $('body').on('click', '#packageAHeader', function () {
      $('#packageAhtml').slideToggle();
      $('#packageBhtml').slideUp();
      $('#packageChtml').slideUp();

      packageAOpen = !packageAOpen;
      packageBOpen = false;
      packageCOpen = false;

      var deg = packageAOpen ? '-180deg' : '0deg';

      $('#packageAHeader img').css('transform', 'rotate(' + deg + ')');
      $('#packageBHeader img').css('transform', 'rotate(0deg)');
      $('#packageCHeader img').css('transform', 'rotate(0deg)');
    });
    $('body').on('click', '#packageBHeader', function () {
      $('#packageAhtml').slideUp();
      $('#packageBhtml').slideToggle();
      $('#packageChtml').slideUp();
      packageAOpen = false;
      packageBOpen = !packageBOpen;
      packageCOpen = false;
      var deg = packageBOpen ? '-180deg' : '0deg';

      $('#packageAHeader img').css('transform', 'rotate(0deg)');
      $('#packageBHeader img').css('transform', 'rotate(' + deg + ')');
      $('#packageCHeader img').css('transform', 'rotate(0deg)');
    });
    $('body').on('click', '#packageCHeader', function () {
      $('#packageBhtml').slideUp();
      $('#packageChtml').slideToggle();
      $('#packageAhtml').slideUp();

      packageAOpen = false;
      packageBOpen = false;
      packageCOpen = !packageCOpen;
      var deg = packageCOpen ? '-180deg' : '0deg';

      $('#packageAHeader img').css('transform', 'rotate(0deg)');
      $('#packageBHeader img').css('transform', 'rotate(0deg)');
      $('#packageCHeader img').css('transform', 'rotate(' + deg + ')');
    });

    var packageAhtml = '';
    var packageBhtml = '';
    var packageChtml = '';

    var rows = pricingTable.find('tr');

    rows.each(function (index) {
      if (index > 0) {
        var td = $(this).children();
        var info = td[0];
        var packA = $(td[1]).html();
        var packB = $(td[2]).html();
        var packC = $(td[3]).html();

        packageAhtml += createMobileRows(info, packA, 'mob_a_' + index);
        packageBhtml += createMobileRows(info, packB, 'mob_b_' + index);
        packageChtml += createMobileRows(info, packC, 'mob_c_' + index);
      }
    });

    $(pricingTable).each(function (table) {
      $(this).after(
        '<h2 class="has-text-align-center"  >Packages</h2><div class="mobile-pricing"><div id="packageAHeader" class="mobile-pricing-header"><div>Roubler core</div><div class="pricing-mobile-pricing-toggle"><img src="' +
          stylesheet_directory_uri +
          '/images/arrow-down.png"></div></div>' +
          '<div id="packageAhtml">' +
          packageAhtml +
          '</div>' +
          '<div  id="packageBHeader"  class="mobile-pricing-header"><div>Roubler all-in-one (most&nbsp;popular)</div><div class="pricing-mobile-pricing-toggle"><img src="' +
          stylesheet_directory_uri +
          '/images/arrow-down.png"></div></div>' +
          '<div id="packageBhtml">' +
          packageBhtml +
          '</div>' +
          '<div  id="packageCHeader" class="mobile-pricing-header"><div>Roubler all-in-one + managed payroll</div><div class="pricing-mobile-pricing-toggle"><img src="' +
          stylesheet_directory_uri +
          '/images/arrow-down.png"></div></div>' +
          '<div id="packageChtml">' +
          packageAhtml +
          '</div>' +
          '</div>'
      );
    });
  }
});
